module.exports = __webpack_public_path__ + "img/img3.5cc8a8f9.jpg";